<template>
  <ResearchGalleryPage
    page-title="论文答辩"
    section-label="研究生教育"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :groups="groups"
  />
</template>

<script>
import ResearchGalleryPage from '@/components/ResearchGalleryPage.vue';

export default {
  name: 'LanhuLunwendabian',
  components: {
    ResearchGalleryPage
  },
  data() {
    return {
      sectionRoute: '/lanhu_jiaoyuyurencai',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      groups: [
        {
          title: '论文答辩',
          kicker: '2001-2018',
          columns: 3,
          items: [
            {
              src: require('./assets/html/defense-2001-master.jpg'),
              caption: '2001 级硕士学位论文答辩会现场'
            },
            {
              src: require('./assets/html/defense-2011-doctor-1.jpg'),
              caption: '2011 年，博士学位论文答辩会后学生与答辩老师合影'
            },
            {
              src: require('./assets/html/defense-2011-doctor-2.jpg'),
              caption: '2011 年，博士学位论文答辩会后学生与答辩老师合影'
            },
            {
              src: require('./assets/html/defense-2012-doctor.jpg'),
              caption: '2012 年，博士学位论文答辩会后学生与答辩老师合影'
            },
            {
              src: require('./assets/html/defense-2015-doctor.jpg'),
              caption: '2015 年，博士学位论文答辩会后学生与答辩老师合影'
            },
            {
              src: require('./assets/html/defense-2018-doctor.jpg'),
              caption: '2018 年，博士学位论文答辩会后学生与答辩老师合影'
            }
          ]
        }
      ]
    };
  }
};
</script>
